import { Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PaymentSettingsService } from 'app/core/http/services/payment-settings.service';
import { PaymentSettings } from 'app/core/interfaces/payment-settings';
import { BaseComponent } from 'app/modules/shared/components/base.component';

// Interfaces simplificadas
interface Agreement {
  name: string;
  discount_rate: Number;
  accepted: boolean;
}

interface HealthPlan {
  name: string;
  accepted: boolean;
  agreements: Agreement[];
}

@Component({
  selector: 'src-health-insurance',
  templateUrl: './health-insurance.component.html',
  styleUrls: ['./health-insurance.component.css']
})
export class HealthInsuranceComponent extends BaseComponent implements OnInit {

  public title = 'Planos de Saúde';
  public form!: FormGroup;
  public healthPlans: HealthPlan[] = [];
  public mode = 'CREATE';
  public organizationSettings!: PaymentSettings;

  // Status da submissão
  public submittedSettings = false;
  public successSettings = false;

  // Estrutura de planos e convênios
  healthPlansOrganization = [
    {
      name: "Unimed",
      agreements: [
          {
            name: "Regional 40%",
            discount_rate: 40
          },
          {
            name: "Regional 60%",
            discount_rate: 60
          },
          {
            name: "Cooparticipacao",
            discount_rate: 100
          }
      ]
    },
    {
      name: "Bradesco Saúde",
      agreements: [
          {
            name: "Regional 40%",
            discount_rate: 40
          },
          {
            name: "Regional 60%",
            discount_rate: 60
          },
          {
            name: "Cooparticipacao",
            discount_rate: 100
          },
          {
            name: "Familiar",
            discount_rate: 10
          }
      ]
    }
  ];

  constructor(
    private fb: FormBuilder,
    private organizationSettingsService: PaymentSettingsService,
    private injector: Injector
  ) {
    super(injector);
  }

   ngOnInit() {
     this.getSettings(); // Aguarda a obtenção das configurações
     this.form = this.fb.group({ healthPlans: this.fb.array(this.createHealthPlans()) });
  }

  createHealthPlans(): FormGroup[] {
    return this.healthPlansOrganization.map(planOrg => {
      const matchingPlan = this.healthPlans.find(plan => plan.name === planOrg.name) || { accepted: false, agreements: [] };
      return this.fb.group({
        name: [planOrg.name],
        accepted: [matchingPlan.accepted],
        agreements: this.fb.array(planOrg.agreements.map(agreementOrg => {
          const matchingAgreement = matchingPlan.agreements.find(a => a.name === agreementOrg.name) || { accepted: false };
          return this.fb.group({
            name: [agreementOrg.name],
            discount_rate: agreementOrg.discount_rate,
            accepted: [matchingAgreement.accepted]
          });
        }))
      });
    });
  }

  getHealthPlansFormArray(): FormArray {
    return this.form.get('healthPlans') as FormArray;
  }

  getSettings(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.organizationSettingsService.findByOrganization(this.getUserLogged().id)
        .subscribe({
          next: (settings: PaymentSettings) => {
            this.organizationSettings = settings;
            
            // Preencher healthPlans com os dados do settings ou valores padrão
            this.healthPlans = settings.healthcare_plans || this.healthPlansOrganization.map(plan => ({
              name: plan.name,
              accepted: false,
              agreements: plan.agreements.map(agreement => (
                  {
                    name: agreement.name,
                    discount_rate: agreement.discount_rate,
                    accepted: false
                  }
              ))
            }));
            
            // Definindo o modo (CREATE ou UPDATE)
            this.mode = settings ? 'UPDATE' : 'CREATE';
  
            // Popular o formulário com os dados obtidos
            this.form.setControl('healthPlans', this.fb.array(this.createHealthPlans()));
  
            // Resolver a promise após o preenchimento do formulário
            resolve();
          },
          error: (err) => reject(err)
        });
    });
  }
  

  createOrUpdate() {
    if (this.mode === 'CREATE') {
      this.createSettings();
    } else {
      this.updateSettings();
    }
  }

  createSettings() {
    const settings: PaymentSettings = {
      organization_id: this.getUserLogged().id,
      payment_methods: [],
      healthcare_plans: this.form.value.healthPlans,
    };

    this.organizationSettingsService.create(settings)
      .subscribe({
        next: (newSettings) => this.handleSuccess(newSettings),
        error: (err) => this.handleError(err)
      });
  }

  updateSettings() {
    this.organizationSettings.healthcare_plans = this.form.value.healthPlans;

    this.organizationSettingsService.update(this.organizationSettings, this.organizationSettings.payment_settings_id!)
      .subscribe({
        next: (updatedSettings) => this.handleSuccess(updatedSettings),
        error: (err) => this.handleError(err)
      });
  }

  handleSuccess(settings: PaymentSettings) {
    this.organizationSettings = settings;
    this.submittedSettings = true;
    this.successSettings = true;
    console.log("Operação bem-sucedida", settings);
  }

  handleError(error: any) {
    console.error("Erro na operação", error);
    this.submittedSettings = true;
    this.successSettings = false;
  }

 
  
  getAgreementsFormArray(planIndex: number): FormArray {
    return this.getHealthPlansFormArray().at(planIndex).get('agreements') as FormArray;
  }
  

  submit() {
    console.log(this.form.value);
  }
}
